import { VariantFieldsFragment } from './../../../services/shopify/generated';
import { convertShopifyPathIdToNumber } from ".";
import {  getBaseUrlFromLocale, getFirstVariant, getGPCFromProduct, getOriginalSrcFromProduct, getVariantsFromProduct } from "../getters";
import { constructShopifyImageUrlLarge } from '..';


export function transformSchemaProduct(locale: any, shopifyProduct: any) {
  const variants = getVariantsFromProduct(shopifyProduct);
  const variant = getFirstVariant(shopifyProduct)
  const originalImageUrl = getOriginalSrcFromProduct(shopifyProduct);
  const productNumber = convertShopifyPathIdToNumber(shopifyProduct.id)

  const offers = variants.map((v: VariantFieldsFragment) => {
    return {
      '@type': 'Offer',
      price: parseFloat(v.price.amount).toFixed(2),
      priceCurrency: v.price.currencyCode,
      gtin: v.barcode,
      itemCondition: 'https://schema.org/NewCondition',
      availability: `http://schema.org/${
        v.availableForSale ? 'InStock' : 'OutOfStock'
      }`,
    }
  })

  const schema = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    brand: {
      '@type': 'Brand',
      name: shopifyProduct.vendor,
    },

    name: shopifyProduct.title,
    description: shopifyProduct.description.slice(0, 255),
    url: `${getBaseUrlFromLocale(locale)}/products/${shopifyProduct.handle}`,
    image: constructShopifyImageUrlLarge(originalImageUrl),

    offers,
    sku: variant.sku,
    gtin: variant.barcode,
    productID: productNumber,
    category: getGPCFromProduct(shopifyProduct),
    // price: `${variant.price.amount} ${variant.price.currencyCode}`,
    // availability: `http://schema.org/${v.availableForSale ? "InStock" : "OutOfStock"}`,
  }

  return schema
}